import { motion } from "framer-motion";
import { Clock } from "lucide-react";
import { MASSAGES } from "@/data/site";
import SectionLabel from "./SectionLabel";

export default function Massages({ onBook }) {
  return (
    <section
      id="massages"
      className="relative py-24 md:py-32 bg-[#F9F6F0]"
      data-testid="massages-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <SectionLabel
          eyebrow="Nos Soins"
          title={<>Une carte de soins<br /><span className="italic text-[#8B5A2B]">pensée pour vous</span></>}
          subtitle="Chaque massage est une invitation à ralentir. Choisissez le rituel qui vous ressemble — du soin signature aux soins ciblés."
        />

        <div className="space-y-20 md:space-y-32">
          {MASSAGES.map((m, idx) => (
            <motion.article
              key={m.id}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
              className={`grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 items-center ${
                idx % 2 === 1 ? "md:[&>*:first-child]:order-2" : ""
              }`}
              data-testid={`massage-card-${m.id}`}
            >
              {/* Image */}
              <div className="relative overflow-hidden rounded-2xl group">
                <motion.img
                  src={m.image}
                  alt={m.name}
                  initial={{ scale: 1.1 }}
                  whileInView={{ scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 1.4, ease: "easeOut" }}
                  className="w-full aspect-[4/5] object-cover transition-transform duration-[1.4s] group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-stone-900/20 to-transparent" />
                <div className="absolute top-6 left-6 px-3 py-1.5 rounded-full bg-white/80 backdrop-blur-md text-stone-900 text-[10px] tracking-[0.3em] uppercase font-body">
                  0{idx + 1}
                </div>
              </div>

              {/* Content */}
              <div>
                <h3 className="font-display font-light text-stone-900 text-3xl md:text-4xl lg:text-5xl leading-tight tracking-tight">
                  {m.name}
                </h3>
                <div className="mt-4 w-12 h-px bg-[#C5A059]" />
                <p className="mt-6 text-stone-600 font-light text-base md:text-lg leading-relaxed">
                  {m.description}
                </p>

                <div className="mt-8 space-y-3">
                  {m.options.map((o) => (
                    <div
                      key={o.duration}
                      className="flex items-baseline justify-between border-b border-[#E6DFD3] pb-3"
                    >
                      <div className="flex items-center gap-3">
                        <Clock strokeWidth={1.2} className="w-4 h-4 text-[#8B5A2B]" />
                        <span className="font-body text-stone-700 text-sm tracking-wide uppercase">
                          {o.duration}
                        </span>
                      </div>
                      <span className="font-display text-[#8B5A2B] text-2xl font-medium">
                        {o.price}
                      </span>
                    </div>
                  ))}
                </div>

                <button
                  onClick={onBook}
                  data-testid={`massage-book-${m.id}`}
                  className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-full border border-stone-900 text-stone-900 font-body text-sm font-medium hover:bg-stone-900 hover:text-[#F9F6F0] transition-all duration-500"
                >
                  Réserver ce soin
                  <span>→</span>
                </button>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
